export const root = '/';
export const dashboard = '/Dashboard';
export const home = '/Dashboard/Home';
export const loginForm = '/Login';
export const settings = '/Settings';
export const about = '/Settings/About';
export const appDownload = '/AppDownload';